import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeQuoteSettings } from './normalize';

export const fetchQuoteModuleSettings = createProvider(api.fetchQuoteModuleSettings)
  .andThen((res) => normalizeQuoteSettings(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
